import React from 'react';
import PropTypes from 'prop-types';
import BoxContainer from '~src/components/BoxContainer';
import CreditsOrders from '~src/components/Removebg/CreditsOrders';
// Using GDS buttons (styles/design-system)
import triggerChatFlow from '~src/utils/triggerChatFlow';

const Storico = (props) => {
  const Content = () => (
    <>
      <p className="lead text-dark mb-0">Ultimi 30 utilizzi</p>

      <CreditsOrders orders={props.orders} />
      <button
        type="button"
        className="g-btn g-btn-outline g-btn-danger g-btn-size-sm"
        onClick={() =>
          triggerChatFlow(
            'Salve, sto riscontrando un problema con i crediti. Descrizione del problema: '
          )
        }
      >
        Riporta un problema
      </button>
    </>
  );

  if (props.flat) {
    return <Content />;
  }

  return (
    <BoxContainer
      xsColSize={12}
      xsColOffset={0}
      smColSize={10}
      smColOffset={1}
      lgColSize={6}
      lgColOffset={3}
      theme="light"
    >
      <Content />
    </BoxContainer>
  );
};

Storico.propTypes = {
  orders: PropTypes.array,
  flat: PropTypes.bool,
};

export default Storico;
